import {CustomerSubscription,} from '../types';
import {
    PlatformPropertyCard,
    PlatformPropertyCardCopyButtonDecorator,
    PlatformPropertyCardProperty
} from "@flexinet/ui-components";
import {useAllowedItems} from "../../../hooks/useAllowedProperties.ts";
import {CreatedByProfileFormatter} from "../../../components/CreatedByProfileFormatter.tsx";
import {Stack} from "@mantine/core";
import {CustomerDetailPageLink} from "../../customers/links/CustomerDetailPageLink.tsx";


export const Profile = ({record}: { record: CustomerSubscription }) => {

    const properties = [
        {
            label: 'ID',
            value: record.id as string,
            span: 12,
        }, {
            label: 'Customer',
            value: <CustomerDetailPageLink id={record.customerId as string}/>,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        }] as PlatformPropertyCardProperty[];

    const properties2 = [
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Created By',
            value: <CreatedByProfileFormatter record={record as any}/>,
            rbac: 'UpdateCustomerSubscription',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }] as PlatformPropertyCardProperty[];

    const {filterAllowed} = useAllowedItems()
    const allowedProperties = filterAllowed(properties) as PlatformPropertyCardProperty[];

    return (
        <Stack gap={'lg'}>
            <PlatformPropertyCard properties={allowedProperties}/>
            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};
